


interface LoadingStateProps {
  message: string;
  debug?: {
    walletAddress?: string;
    state?: string;
    error?: string;
  };
  showDebug?: boolean;
}

export const LoadingState = ({ message, debug, showDebug = false }: LoadingStateProps) => {
  return (
    <div className="max-w-2xl mx-auto p-8 flex flex-col justify-center items-center">
      <div className="flex flex-col items-center space-y-4">
        <div className="relative w-16 h-16">
          <div className="absolute top-0 left-0 w-full h-full border-4 border-primary rounded-full border-t-transparent animate-spin"></div>
          <img 
            src="/lovable-uploads/clr_4.png" 
            alt="Bromentum Logo" 
            className="w-10 h-10 object-contain absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
          />
        </div>
        <p className="text-lg">{message}</p>
        
        {/* Debug information - only shown when showDebug is true */}
        {showDebug && debug && (
          <div className="mt-4 p-4 bg-navy-dark rounded-lg text-sm overflow-auto max-w-full">
            <h4 className="text-tan font-bold mb-2">Debug Info:</h4>
            {debug.walletAddress && <p className="text-gray-300">Wallet: {debug.walletAddress}</p>}
            {debug.state && <p className="text-gray-300">State: {debug.state}</p>}
            {debug.error && (
              <div>
                <p className="text-red-400 font-bold">Error:</p>
                <pre className="text-red-400 overflow-x-auto whitespace-pre-wrap">{debug.error}</pre>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
